exports = module.exports = require("../../../build/module-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".channel-web__style__overlay___2XR4Y {\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 9998; }\n", ""]);

// exports
exports.locals = {
	"overlay": "channel-web__style__overlay___2XR4Y"
};